module.exports = __webpack_public_path__ + "static/media/wallet.4c618153.svg";